var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"main-button",class:( _obj = {
    'main-button--outline': _vm.outline
  }, _obj[("main-button--" + _vm.severity)] = !!_vm.severity, _obj ),attrs:{"disabled":_vm.disabled,"data-progress":_vm.progress ? 'true' : 'false',"type":_vm.type,"data-color":_vm.color},on:{"click":_vm.changeEvent}},[_c('span',{staticClass:"main-button__label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"main-button__loader"},[_c('Loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }